import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'

import modules from './modules'

Vue.use(VueCookies)
Vue.use(Vuex)

const store = new Vuex.Store({
	modules,
	// Enable strict mode in development to get a warning
	// when mutating state outside of a mutation.
	// https://vuex.vuejs.org/guide/strict.html
	strict: process.env.NODE_ENV !== 'production',
	state: {
		authToken: null,
	},
	mutations: {
		SET_CURRENT_USER: function(state, newValue) {
			state.authToken = newValue
		},
		logout: function(state) {
			sessionStorage.clear()
			state.authToken = null
			Vue.$cookies.remove("authToken")
		}
	},
	getters: {
		loggedIn: function() {
			return Vue.$cookies.get("authToken") !== null
		}
	},
})

export default store
